<template>
    <FloatingTabs
        v-if="$page.props.availableLocales.length > 1"
        @TabClicked="changeLocale"
        :tabs="tabs"
        :activeTabSlug="currentLocale"
        containerPadding="p-0.5"
        buttonPadding="py-1 px-1.5"
        buttonRounded="rounded-xl"
        containerRounded="rounded-full"
        :verticalOnMobile="false"
    />
</template>

<script>
import FloatingTabs from '@/Components/Elements/FloatingTabs.vue'
import { router } from '@inertiajs/vue3'

export default {
    components: {
        FloatingTabs,
    },

    data: () => ({
        currentLocale: 'en',
    }),

    created() {
        this.tabs = [
            {
                slug: 'en',
                // text: this.$lang.get("English"),
                icon: `<div class="fi fi-gb w-6 h-4 bg-cover border border-black/70 rounded-sm"/>`,
            },
            {
                slug: 'sv',
                // text: this.$lang.get("Swedish"),
                icon: `<div class="fi fi-se w-6 h-4 bg-cover border border-black/70 rounded-sm"/>`,
            },
        ]
        this.currentLocale = this.$page.props.locale
    },

    methods: {
        changeLocale(locale) {
            this.currentLocale = locale
            router.post(route('profile.updateLocale'), { locale: locale })
        },
    },
}
</script>
